<svg class="svg_icon--down_chevron" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
  <defs>
    <style>.svg_icon--down_chevron .icon{fill:currentColor;}</style>
  </defs>
  <title>Open</title>
  <g>
    <path class="icon"
          d="M85.44,39.09a5.78,5.78,0,0,1-1.63,4h0L53.16,74.06a4.12,4.12,0,0,1-6,0L16.5,43.12a5.79,5.79,0,0,1,0-8.08,5.67,5.67,0,0,1,8,0L50.15,60.83,75.71,35.05a5.66,5.66,0,0,1,8,0,5.59,5.59,0,0,1,1.72,4Z"/>
  </g>
</svg>
